import fetch from '@/plugins/fetch'
import utils from '@/plugins/utils'
import queryString from 'query-string'
import { PREFIX_BIGYUER_API, PREFIX_SCC_API, PREFIX_SCB_API } from '@/service'
const api = {
  cateOne: PREFIX_BIGYUER_API + 'getSearchItemDetailList',
  cateTwo: PREFIX_BIGYUER_API + 'getServeItemList4City',
  categoryListUrl: PREFIX_SCC_API + 'fchild/applyJoin/queryCategorys.do',
  categoryListUrlNew: '//api.czj100.com/category/yuerNavList',
  searchItem: PREFIX_BIGYUER_API + 'getSearchItemList4City',
  daodianCategoryUrl: PREFIX_SCB_API + 'appStore/queryDaoDianCategory.do'
}
export default {
  async getSearchItemByCity({ commit }, { gbCode }) {
    // console.log(gbCode)
    const query = queryString.stringify({ gbCode })
    const res = await fetch(`${api.searchItem}?${query}`)
    const json = await res.json()
    return json.content && json.content.result
  },
  async getCategoryList({ commit, state }, { managerUid }) {
    try {
      const query_param = {
        managerUid
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.categoryListUrl}?${query}`)
      const json = await res.json()
      let list = []
      if (json.code === '1') {
        list = json.data || []
        commit('setCategoryList', list)
      } else {
        throw new Error(json.code)
      }
      return list
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async getCategoryListNew() {
    try {
      const res = await fetch(api.categoryListUrlNew)
      const json = await res.json()
      return json
    } catch (e) {
      throw new Error(e.message)
    }
  },
  async getCateOneTwo() {
    try {
      const res = await fetch(api.cateOne)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCateTwo({ commit }, { citycode, cateOneId }) {
    try {
      const query = queryString.stringify({
        gbCode: citycode,
        serveItem: cateOneId
      })
      const res = await fetch(`${api.cateTwo}?${query}`)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
    }
  },
  async getDaodianCategory({ commit, state }, { businessType }) {
    try {
      const query_param = {
        businessType
      }
      const query = queryString.stringify(query_param)
      const res = await fetch(`${api.daodianCategoryUrl}?${query}`)
      const json = await res.json()
      let list = []
      if (json.code === '1') {
        list = json.data || []
      }
      return list
    } catch (e) {
      return []
    }
  }
}
